import { render, staticRenderFns } from "./leads.vue?vue&type=template&id=b07f12fe&scoped=true&"
import script from "./leads.vue?vue&type=script&lang=js&"
export * from "./leads.vue?vue&type=script&lang=js&"
import style0 from "./leads.vue?vue&type=style&index=0&id=b07f12fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07f12fe",
  null
  
)

export default component.exports